import { FC, memo, PropsWithChildren } from "react";
import "./panel-footer.scss";

interface PanelFooterProps extends PropsWithChildren {
  placement?: "right" | "center" | "between" | "around";
  position?: "fixed" | "relative" | "sticky";
  className?: string;
}

const PanelFooterComponent: FC<PanelFooterProps> = ({
  placement = "right",
  position = "",
  className = "",
  children,
}) => {
  return <div className={`panel-footer ${placement} ${position} ${className}`}>{children}</div>;
};

export const PanelFooter = memo(PanelFooterComponent);
